module.exports = __webpack_public_path__ + "assets/img/img182.bbc29b58.png";